import {Component, Input, OnInit} from '@angular/core';

export interface TractorsAvgAgePerDomain {
  domainID: number;
  domainName: string;
  data: { range: string, count: number }[];
}

@Component({
  selector: 'app-tractors-avg-age-per-domain-widget',
  templateUrl: './tractors-avg-age-per-domain-widget.component.html',
  styleUrls: ['./tractors-avg-age-per-domain-widget.component.scss']
})
export class TractorsAvgAgePerDomainWidgetComponent implements OnInit {

  @Input()
  data: TractorsAvgAgePerDomain[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
